import React, { useState } from 'react';
import BannersContext from './Banners.context';

type BannersProps = {
  children: JSX.Element;
};

const Banners: React.FC<BannersProps> = (props) => {
  const { children } = props;

  const [showRenew, setShowRenew] = useState(true);
  const [showLink, setShowLink] = useState(true);
  const [showSettlePayment, setShowSettlePayment] = useState(true);

  const updateRenewBanner = (show: boolean) => setShowRenew(show);
  const updateLinkBanner = (show: boolean) => setShowLink(show);
  const updateSettlePaymentBanner = (show: boolean) =>
    setShowSettlePayment(show);

  return (
    <BannersContext.Provider
      value={{
        showRenew,
        showLink,
        showSettlePayment,
        updateRenewBanner,
        updateLinkBanner,
        updateSettlePaymentBanner,
      }}
    >
      {children}
    </BannersContext.Provider>
  );
};

export default Banners;
